import React from "react";

export type IColorsIconProps = {};

const ColorsIcon: React.FC<IColorsIconProps> = () => {
 return (
  <svg
   xmlns="http://www.w3.org/2000/svg"
   width={53.461}
   height={53.461}
   viewBox="0 0 53.461 53.461"
  >
   <g data-name="Group 5669" fill="#7c7c7c">
    <path
     data-name="Path 373"
     d="M21.89 18.787a4.661 4.661 0 00-.351-6.59 4.684 4.684 0 00-6.6.351 4.67 4.67 0 006.95 6.239zm-6.056-2.982a2.585 2.585 0 114.5 1.584 2.593 2.593 0 01-3.653.193 2.556 2.556 0 01-.847-1.777z"
    />
    <path
     data-name="Path 374"
     d="M31.15 27.093a4.672 4.672 0 106.6-.354 4.687 4.687 0 00-6.6.354zm1.552 1.4a2.6 2.6 0 013.653-.2 2.575 2.575 0 01.193 3.639 2.593 2.593 0 01-3.653.193 2.571 2.571 0 01-.194-3.637z"
    />
    <path
     data-name="Path 375"
     d="M33.844 14.796a4.681 4.681 0 00-6.6.351 4.674 4.674 0 106.6-.351zm-1.2 5.192a2.59 2.59 0 01-3.653.193 2.583 2.583 0 113.653-.193z"
    />
    <path
     data-name="Path 376"
     d="M8.205 25.945a6 6 0 108.463.587 6.01 6.01 0 00-8.463-.587zm7.841 4.788a3.878 3.878 0 01-1.335 2.677 3.925 3.925 0 01-5.521-.382 3.908 3.908 0 015.9-5.122 3.867 3.867 0 01.956 2.827z"
    />
    <path
     data-name="Path 377"
     d="M50.044 7.77a7.355 7.355 0 01-1.1-5.245c.078-.982.152-1.909-.67-2.36-.858-.471-1.765.128-2.953 1.025a18.621 18.621 0 00-5.706 6.668 16.41 16.41 0 00-1.53 4.4 22.393 22.393 0 00-10.848-5.983 1.045 1.045 0 00-.458 2.038 20.308 20.308 0 0111.071 6.77 7.489 7.489 0 002.075 5.251v3.33a1.946 1.946 0 002 1.884h.1v7.028a20.209 20.209 0 01-7.449 11.488l-.03.024a3.353 3.353 0 01-2.5 1.066c-1.077-.215-2.025-1.844-2.9-3.494-1.7-3.2-3.936-4.756-6.824-4.756s-5.12 1.556-6.823 4.756c-.878 1.65-1.826 3.278-2.9 3.494a3.354 3.354 0 01-2.5-1.066l-.03-.023a20.031 20.031 0 01-7.981-16.057A20.327 20.327 0 0117.85 8.313a1.045 1.045 0 00-.458-2.038A22.291 22.291 0 000 28.008a22.012 22.012 0 002.392 10.045 22.477 22.477 0 006.384 7.662C10.317 46.976 11.7 47.462 13 47.2c1.973-.394 3.177-2.382 4.337-4.56 1.344-2.524 2.88-3.649 4.98-3.649s3.637 1.125 4.981 3.649c1.16 2.178 2.364 4.166 4.337 4.56a3.476 3.476 0 00.684.068 5.734 5.734 0 003.537-1.554 22.369 22.369 0 006.169-7.253v11.31a3.693 3.693 0 007.386 0V25.548h.1a1.946 1.946 0 002-1.885v-3.136a3.835 3.835 0 001.72-2.253c.905-2.991-.946-7.43-3.182-10.5zm-8.572 1.047a16.444 16.444 0 015.109-5.96q.14-.106.26-.193A9.03 9.03 0 0048.355 9c2.213 3.04 3.448 6.767 2.872 8.668a1.734 1.734 0 01-.976 1.16h-8.877c-2.2-2.193-1.651-6.629.1-10.01zm4.243 42.554a1.6 1.6 0 01-1.6-1.6v-4.783h3.205v4.785a1.6 1.6 0 01-1.6 1.6zm1.6-8.473h-3.204v-17.35h3.209zm2.1-19.44h-7.4v-2.541h7.4z"
    />
    <path
     data-name="Path 378"
     d="M22.315 7.82a1.045 1.045 0 000-2.089 1.045 1.045 0 000 2.089z"
    />
   </g>
  </svg>
 );
};

export { ColorsIcon };
